import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';
@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class AddSendNotificationComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  sendNotificationForm: FormGroup;
  errorMessage = '';
  submitted = false;
  pagetitle: string;
  pushNotificationTypes: any = [];
  notificationIconPreview: string | null = null;
  notificationIconFile: File | null = null;
  notificationType: string | null = null;
  minYear = environment.minYear;
  yearRange: string;
  id: string;
  isDuplicateNotification: boolean;
  userExcelSheet: any;
  notificationIcon: any;
  minDate:Date = new Date();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;
  isApplyingCrop = false;

  constructor(private pushNotificationService: PushNotificationService, private formBuilder: FormBuilder, private messageService: MessageService,
    private router: Router, private activatedRoute: ActivatedRoute, private confirmationService: ConfirmationService) { }

  async ngOnInit(): Promise<void> {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isDuplicateNotification = this.router.url.includes('duplicate');

    if (!this.isDuplicateNotification) {
      this.pagetitle = (!this.id) ? 'Send Notification' : 'Edit Notification';
    } else {
      this.pagetitle = 'Duplicate Notification';
    }

    this.pushNotificationTypes = [
      { label: 'Push Notification', value: 'push_notification' },
      { label: 'Email', value: 'email' }
    ];
    this.yearRange = this.minYear + ":2030";

    this.sendNotificationForm = this.formBuilder.group({
      excelFile: [null, [Validators.required]],
      type: [null, [Validators.required]],
      icon: [null],
      description: [null],
      headerContent: [null],
      subject: [null],
      emailContent: [null],
      scheduleDate: [null, [Validators.required]],
      status: [true, [Validators.required]]
    });

    if (this.id) {
      this.getSendNotificationDetailsById(this.id);
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.sendNotificationForm.controls;
  }

  get cropDialogTitle(): string {
    return 'Crop & Adjust Notification Icon';
  }

  get cropDialogSubtitle(): string {
    return 'Position and scale your image for a 100 x 100 crop';
  }

  get cropPreviewLabel(): string {
    return '100 x 100 px - High Quality JPEG';
  }

  zoomIn() {
      this.scale += 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }

    zoomOut() {
      if (this.scale > 0.2) {
        this.scale -= 0.1;
        this.transform = {
          ...this.transform,
          scale: this.scale
        };
      }
    }

    resetZoom() {
      this.scale = 1;
      this.transform = {
        ...this.transform,
        scale: 1
      };
    }
    

  getSendNotificationDetailsById(id: string) {
    this.pushNotificationService.getBulkNotificationById(id).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (!this.isDuplicateNotification) {
        this.userExcelSheet = data['excelFile'];
        this.sendNotificationForm.get('excelFile').setValidators(null);
        this.sendNotificationForm.get('excelFile').updateValueAndValidity();
      }
      this.sendNotificationForm.patchValue({
        type: data['type'],
        description: data['description'] ?? null,
        subject: data['subject'] ?? null,
        emailContent: data['emailContent'] ?? null,
        scheduleDate: moment(data['scheduleDate']).toDate(),
        status: data['status'],
        headerContent: data['headerContent'] ?? null
      })
      this.onClickNotificationType({ value: data['type'] });
      if (!this.isDuplicateNotification) {
        this.notificationIcon = data['icon'];
        this.sendNotificationForm.get('icon').setValidators(null);
        this.sendNotificationForm.get('icon').updateValueAndValidity();
      }
    },
    ((err) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Fetch Bulk Notification details failed', life: 6000 });
    }))
  }

  onClickNotificationType(event) {
    this.sendNotificationForm.get('icon').setValidators((event.value === "push_notification") ? [Validators.required] : null);
    this.sendNotificationForm.get('icon').updateValueAndValidity();
    this.sendNotificationForm.get('description').setValidators((event.value === "push_notification") ? [Validators.required] : null);
    this.sendNotificationForm.get('description').updateValueAndValidity();
    this.sendNotificationForm.get('subject').setValidators((event.value === "email") ? [Validators.required] : null);
    this.sendNotificationForm.get('subject').updateValueAndValidity();
    this.sendNotificationForm.get('emailContent').setValidators((event.value === "email") ? [Validators.required] : null);
    this.sendNotificationForm.get('emailContent').updateValueAndValidity();
    this.sendNotificationForm.get('headerContent').setValidators((event.value === "push_notification") ? [Validators.required] : null);
    this.sendNotificationForm.get('headerContent').updateValueAndValidity();
  }

  onSubmit() {
    this.submitted = true;
    if (this.sendNotificationForm.invalid) {
      return;
    }

    var sendNotificationFormData = this.sendNotificationForm.value;
    if (sendNotificationFormData.type === 'push_notification') {
      delete sendNotificationFormData['subject'];
      delete sendNotificationFormData['emailContent'];
    } else {
      delete sendNotificationFormData['icon'];
      delete sendNotificationFormData['description'];
      delete sendNotificationFormData['headerContent'];
    }

    sendNotificationFormData = JSON.stringify(sendNotificationFormData, null, 4);
    if (!this.id || this.isDuplicateNotification) {
      this.addPushNotification(sendNotificationFormData);
    } else {
      this.updatePushNotification(sendNotificationFormData);
    }
  }

  addPushNotification(sendNotificationFormData) {
    this.pushNotificationService.addBulkNotification(sendNotificationFormData).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bulk Notification Added Successfully!!', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/manage/push-notification/send-notification']);
        }, 2000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Bulk Notification failed', life: 6000 });
      })
    );
  }

  updatePushNotification(sendNotificationFormData) {
    this.pushNotificationService.updateBulkNotification(this.id,sendNotificationFormData).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bulk Notification Updated Successfully!!', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/manage/push-notification/send-notification']);
        }, 2000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Bulk Notification failed', life: 6000 });
      })
    );
  }

  onReset() {
    this.submitted = false;
    this.sendNotificationForm.reset();
  }

  backLink() {
    this.router.navigate(['/manage/push-notification/send-notification/']);
  }

  userExcelSheetUploader(event) {
    for (let file of event.files) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.sendNotificationForm.get('excelFile').setValue(e.target.result);
      }
      fileReader.readAsDataURL(file);
    }
  }

  removeUserExcelSheetFile(event) {
    this.sendNotificationForm.get('excelFile').setValue(null);
  }
  
  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.resetZoom();
    this.imageChangedEvent = {
      target: {
        files: [file]
      }
    };
    this.cropDialog = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must not exceed 1 MB.'
      : null;
  }

  onCropImageLoadFailed() {
    this.croppedImage = null;
    this.croppedImageSize = 0;
    this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
  }
        
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

 applyCrop() {

  if (
    this.isApplyingCrop ||
    this.croppedImageError ||
    !this.croppedImage ||
    !this.selectedFile
  ) {
    return;
  }

  this.isApplyingCrop = true;

  const file = this.base64ToFile(
    this.croppedImage,
    this.getOutputFileName(this.selectedFile.name)
  );

  if (file.size > this.croppedImageMaxSize) {

    this.croppedImageError =
      'Cropped image size must not exceed 1 MB.';

    this.isApplyingCrop = false;

    return;
  }

  // Clear old selected file
  if (this.fileUpload) {
    this.fileUpload.clear();
  }

  const event = {
    files: [file]
  };

  // Existing upload flow - DON'T REMOVE
  this.iconUploader(event);

  // Show cropped image preview
  setTimeout(() => {
    this.notificationIcon = this.croppedImage;

    // Optional: keep cropped file in PrimeNG uploader
    if (this.fileUpload) {
      this.fileUpload.files = [file];
    }

    this.isApplyingCrop = false;
  });

  this.cropApplied = true;
  this.cropDialog = false;
}


  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
  }

  onDialogHide() {
    this.resetCropState();
  }

  private resetCropState() {
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.resetZoom();
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
  }

  private getOutputFileName(filename: string | undefined): string {
    const baseName = (filename || 'notification-icon').replace(/\.[^/.]+$/, '');
    return `${baseName}.jpg`;
  }
        
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
    this.onCropCancel();
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  iconUploader(event) {
    for (let file of event.files) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.sendNotificationForm.get('icon').setValue(e.target.result);
      }
      fileReader.readAsDataURL(file);
    }
  }

  removeIcon(event) {
    this.sendNotificationForm.get('icon').setValue(null);
  }

  deleteExcelSheet() {
    this.confirmationService.confirm({
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete the uploaded excel sheet ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      // ❌ Remove icons
      acceptIcon: '',
      rejectIcon: '',
      accept: () => {
        this.userExcelSheet = null;
        this.sendNotificationForm.get('excelFile').setValidators([Validators.required]);
        this.sendNotificationForm.get('excelFile').updateValueAndValidity();
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  deleteNotificationIcon() {
    this.confirmationService.confirm({
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete the uploaded Icon ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      // ❌ Remove icons
      acceptIcon: '',
      rejectIcon: '',
      accept: () => {
        this.notificationIcon = null;
        this.sendNotificationForm.get('icon').setValidators([Validators.required]);
        this.sendNotificationForm.get('icon').updateValueAndValidity();
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
